export { default } from './dist/vue-object-fit.common'
export * from './dist/vue-object-fit.common'
import './dist/vue-object-fit.css'
